import axios from 'axios'
import {
  Loading,
  Message
} from 'element-ui';

var BASE_API = process.env.BASE_API;
if (process.env.NODE_ENV == "development") {
  BASE_API = window.config.BASE_API;
}
var token;
var headers = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
// 创建axios实例
const service = axios.create({
  baseURL: BASE_API, // api的base_url
  // timeout: 15000, // 请求超时时间
  withCredentials: true,
  headers: headers,
  transformRequest: [function (data) {
    // Do whatever you want to transform the data
    let ret = '';
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret.substring(0, ret.length - 1);
  }]
})
let loadingState = true;
let loading;
// request拦截器
service.interceptors.request.use(config => {
  token = JSON.parse(sessionStorage.getItem("userInfo")) ? JSON.parse(sessionStorage.getItem("userInfo"))['access_token'] : '';
  if (token) {
    if (config.url == '/web/user/info' || config.url == '/web/user/contact') {
      config.headers['Content-Type'] = 'application/json;charset=utf8';
    }
    config.headers['Authorization'] = 'Bearer ' + token
  }
  setTimeout(() => {
    if (loadingState) {
      loading = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    }
  }, this.waitTime);
  return config;
}, error => {
  loadingState = false;
  Message.error("网络异常");
  if (loading) {
    loading.close();
  }
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    loadingState = false;
    Message.closeAll();
    if (loading) {
      loading.close();
    }

    const res = response.data;
    if (res.code != 0) {
      Message.error(res.msg);
    }
    return res;
  },
  error => {
    loadingState = false;
    Message.error("网络异常");
    if (loading) {
      loading.close();
    }

    if (typeof (error.response.data.error) != "undefined" && error.response.data.error == "invalid_token") {
      sessionStorage.removeItem("userInfo")
    }
    return Promise.reject(error)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/require.js